let imageCount = 0;
let observer;
let domObserver;
let dynamicWidthImages = [];
let running = false;
let currentlyAnimating = [];

const config = {
    // If the image gets within 50px in the Y axis, start the download.
    rootMargin: '50px 0px',
    threshold: 0.01
};

const domConfig = {
    childList: true,
    subtree: true,
    attributes: true
};

// If we don't have support for intersection observer, load the images immediately
if(!('Promise' in window) || !('IntersectionObserver' in window)){
    let images = document.querySelectorAll('.js-lazy-image');
    loadImagesImmediately(images);

}else{
    // It is supported, load the images
    observer = new IntersectionObserver(onIntersection, config);
    
    initLazyLoad(document);
}

// Quand que tous est prêt, on active le mutateur du DOM.
window.onload = function(){
    domObserver = new MutationObserver(domChanged);
    domObserver.observe(document, domConfig);
}


/**
 * Prépare le lazyload sur tous les images contenu dans le sélecteur.
 * 
 * @param {Node} selector 
 */
function initLazyLoad(selector){
    // Get all of the images
    if(typeof selector.querySelectorAll !== 'undefined'){
        const images = selector.querySelectorAll('.js-lazy-image');

        if(images.length){
            imageCount += images.length;

            for (let i = 0; i < images.length; i++) { 
                let image = images[i];
                if (image.classList.contains('js-lazy-image--handled')) {
                    continue;
                }
            
                observer.observe(image);
            }
        }
    }
}


/**
 * Est appelé par un mutateur à chaque fois qu'un élément de la page est ajouté/supprimé ou qu'un attribut est modifié.
 * Ceci permet d'avoir le lazyload fonctionnel avec toutes les modifications sur le DOM.
 * 
 * @param {Object} mutations 
 */
function domChanged(mutations){
    mutations.forEach(function(mutation){
        if(mutation.type == 'childList'){
            let addedNodes = mutation.addedNodes;
            let removedNodes = mutation.removedNodes;

            if(addedNodes.length){ // Nouveau contenu ajouté
                for(let i = 0; i < addedNodes.length; i++){
                    initLazyLoad(addedNodes[i]);
                }
            }

            if(mutation.removedNodes.length){ // Contenu supprimé
                for(let i = 0; i < removedNodes.length; i++){
                    if(typeof removedNodes[i].querySelectorAll !== 'undefined'){
                        const images = removedNodes[i].querySelectorAll('.js-lazy-image');

                        for (let i = 0; i < images.length; i++) { 
                            let image = images[i];
                            
                            imageCount--;
                            observer.unobserve(image);
                        }
                    }
                }
            }
        }else if(mutation.type == 'attributes' && !running && dynamicWidthImages.length){
            running = true;
            requestAnimationFrame(function() {
                for(let i = 0; i < dynamicWidthImages.length; i++){
                    changeImageSize(dynamicWidthImages[i]);
                };
                running = false;
            });
        }
	}); 
}



/**
 * Fetchs the image for the given URL
 * @param {string} url 
 */
function fetchImage(url) {
    return new Promise((resolve, reject) => {
        const image = new Image();

        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
    });
}


/**
 * Preloads the image
 * @param {object} image 
 */
function preloadImage(image) {
    const src = image.dataset.src;
    const type = image.tagName.toLowerCase();

    if (!src) {
        return;
    }
    
    if(type == 'iframe'){
        return applyImage(image, src);

    }else{
        return fetchImage(src).then(() => { applyImage(image, src); });
    }
}


/**
 * Load all of the images immediately
 * @param {NodeListOf<Element>} images 
 */
function loadImagesImmediately(images) {
    for (let i = 0; i < images.length; i++) { 
        let image = images[i];
        const src = image.dataset.src;

        applyImage(image, src);
    }
}


/**
 * Disconnect the observer
 */
function disconnect() {
    if (!observer) {
        return;
    }
  
    observer.disconnect();
}


function onIntersection(entries) {
    // Disconnect if we've already loaded all of the images
    if (imageCount === 0) {
        observer.disconnect();
    }

	// Loop through the entries
	for (let i = 0; i < entries.length; i++) {
        let entry = entries[i];
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
            imageCount--;

            // Stop watching and load the image
            observer.unobserve(entry.target);
            preloadImage(entry.target);
        }
    }
}


/**
 * Apply the image
 * @param {object} img 
 * @param {string} src 
 */
function applyImage(img, src) {
    const srcset = img.dataset.srcset;
    const sizes = img.dataset.sizes;

    // Prevent this from being lazy loaded a second time.
    img.classList.add('js-lazy-image--handled');
    img.src = src;

    if(srcset){
        img.srcset = srcset;
        img.removeAttribute('data-srcset');
    }

    if(sizes == 'auto'){
        addImageWidthListener(img);
        img.removeAttribute('data-sizes');
    }

    img.classList.remove('js-lazy-image');
    img.removeAttribute('data-src');

    img.dispatchEvent(new CustomEvent('lazyloaded'));
}


/**
 * Ajoute tous les listener, mutateur requis pour que l'attribut size de l'image corresponde à la largeur réel de l'image.
 * 
 * @param {Node} img 
 */
function addImageWidthListener(img){
    dynamicWidthImages.push(img); // Ajoute l'image dans le tableau pour le resize.
    changeImageSize(img);

    // ajoute un mutateur pour changer le width de l'image lorsqu'une attribut est changé.
    const sizeConfig = {
        attributes: true
    };
    let attrObserver = new MutationObserver(watchAttrChange);

    attrObserver.observe(img, sizeConfig);

    // Ajoute un listener sur l'image pour que à chaque début de trasition de width, on change la valeur pour représenter celle animé.
    img.addEventListener('transitionstart', function(transition){
        changeImageSize(transition.target);
    });

    // à la fin de la transition, on update la valeur du width.
    img.addEventListener('transitionend webkitTransitionEnd oTransitionEnd', function(transition){
        changeImageSize(transition.target);
    });
}


/**
 * Callback pour le mutateur des images à largeur variable.
 * Lorsqu'un attribut sur une image change, on vérifie sa largeur.
 * 
 * @param {Object} mutations 
 */
function watchAttrChange(mutations){
    mutations.forEach(function(mutation) {
        if(mutation.type == 'attributes'){
            changeImageSize(mutation.target);
        }
    });
}


/**
 * Change la l'attribut sizes de l'image seulement si celle-ci à changé.
 * 
 * @param {Node} img
 */
function changeImageSize(img, checkupCall){
    if(currentlyAnimating.includes(img)){
        return false;
    }
    
    let newImageWidth = img.width+'px';
    checkupCall = (typeof checkupCall === 'undefined') ? false : checkupCall;
    
    if(newImageWidth != img.sizes){
        currentlyAnimating.push(img);
        requestAnimationFrame(function() {
            img.sizes = img.width+'px';

            setTimeout(function(){
                for(let key in currentlyAnimating){
                    if(currentlyAnimating[key] == img){
                        currentlyAnimating.splice(key, 1);
                    }
                }

                changeImageSize(img, true);
            }, 100);
        });

    }else if(!checkupCall){
        setTimeout(function(){
            changeImageSize(img, true);
        }, 200);
    }
}


/**
 * Ajoute un listener sur notre event custom qui change l'attribut sizes de toutes les images
 * qui ont une largeur variable.
 */
window.addEventListener("optimizedResize", function() {
    if(dynamicWidthImages.length){
        for(let i = 0; i < dynamicWidthImages.length; i++){
            changeImageSize(dynamicWidthImages[i]);
        }
    }
});


/**
 * Ajoute un event identique à resize, mais qui demande moins de ressources. 
 */
(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            running = true;
             requestAnimationFrame(function() {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    throttle("resize", "optimizedResize");
})();